import { callObsidianAI } from '../utils/obsidian';
import React, { useState } from 'react';
import { MdAutoAwesome, MdTrendingUp, MdSearch, MdLightbulb, MdBarChart, MdStar } from 'react-icons/md';
import { FaYoutube, FaFacebook, FaTiktok, FaInstagram } from 'react-icons/fa';

const platforms = [
  { id: 'youtube', label: 'YouTube', icon: <FaYoutube style={{ fontSize: '24px', color: '#ff0000' }} />, color: '#ff0000', bg: 'rgba(255,0,0,0.08)', border: 'rgba(255,0,0,0.2)' },
  { id: 'facebook', label: 'Facebook', icon: <FaFacebook style={{ fontSize: '24px', color: '#1877f2' }} />, color: '#1877f2', bg: 'rgba(24,119,242,0.08)', border: 'rgba(24,119,242,0.2)' },
  { id: 'tiktok', label: 'TikTok', icon: <FaTiktok style={{ fontSize: '24px', color: '#e0e0e0' }} />, color: '#e0e0e0', bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.1)' },
  { id: 'instagram', label: 'Instagram', icon: <FaInstagram style={{ fontSize: '24px', color: '#e1306c' }} />, color: '#e1306c', bg: 'rgba(225,48,108,0.08)', border: 'rgba(225,48,108,0.2)' }
];

const categories = [
  { id: 'niches', label: 'Niche Research', icon: <MdSearch /> },
  { id: 'keywords', label: 'Keywords & SEO', icon: <MdTrendingUp /> },
  { id: 'strategy', label: 'Content Strategy', icon: <MdLightbulb /> },
  { id: 'analytics', label: 'Growth Analytics', icon: <MdBarChart /> },
  { id: 'monetisation', label: 'Monetisation', icon: <MdStar /> },
  { id: 'viral', label: 'Viral Tactics', icon: <MdAutoAwesome /> }
];

const quickQuestions = {
  youtube: {
    niches: [
      'What are the most profitable YouTube niches in 2026 with low competition?',
      'Which YouTube niches are growing fastest right now in 2026?',
      'What are the best faceless YouTube channel niches to start in 2026?',
      'Which YouTube niches work best for creators in Pakistan and South Asia?',
      'What YouTube niches have the highest RPM and advertiser demand in 2026?',
      'How do I validate a YouTube niche before spending time creating content?'
    ],
    keywords: [
      'How does YouTube SEO work in 2026 and what has changed recently?',
      'What is the best free method to find low competition YouTube keywords in 2026?',
      'How do I use YouTube search suggestions to find trending keywords?',
      'What role do tags play in YouTube SEO in 2026 and are they still important?',
      'How do I optimise my YouTube title for both search and click through rate?',
      'What are the best keyword research strategies for small YouTube channels?'
    ],
    strategy: [
      'What is the optimal upload frequency for a new YouTube channel in 2026?',
      'How long should YouTube videos be in 2026 for maximum watch time?',
      'What is the best content calendar strategy for YouTube in 2026?',
      'How do I create YouTube Shorts alongside long form content effectively?',
      'What makes a YouTube thumbnail get clicked in 2026 according to data?',
      'How do I create a content series that keeps viewers coming back every week?'
    ],
    analytics: [
      'What are the most important YouTube Studio metrics to track in 2026?',
      'What click through rate should I aim for on YouTube in 2026?',
      'How do I improve my YouTube audience retention percentage?',
      'What does the YouTube algorithm prioritise most in 2026?',
      'How do I use YouTube analytics to find my best performing content types?',
      'What is a good subscriber to views ratio for a healthy YouTube channel?'
    ],
    monetisation: [
      'What are the YouTube Partner Program requirements in 2026?',
      'What is the average YouTube RPM in 2026 per niche and per region?',
      'What are the best ways to monetise a YouTube channel beyond AdSense in 2026?',
      'How do I get brand deals and sponsorships as a small YouTube creator?',
      'How do YouTube Super Thanks and channel memberships work in 2026?',
      'What is the fastest legal way to reach YouTube monetisation in 2026?'
    ],
    viral: [
      'What makes a YouTube video go viral in the algorithm in 2026?',
      'How do I get my videos into YouTube Suggested and Recommended in 2026?',
      'What are the best hook structures for YouTube videos in 2026?',
      'How do YouTube Shorts help a main channel grow in 2026?',
      'What is the best posting time on YouTube for maximum initial views in 2026?',
      'How do I reverse engineer viral YouTube videos in my niche?'
    ]
  },
  facebook: {
    niches: [
      'What are the best Facebook page niches for organic reach in 2026?',
      'Which Facebook page niches grow the fastest with video content in 2026?',
      'What type of Facebook pages get the most engagement in 2026?',
      'Which niches get the most Facebook video views and shares in 2026?',
      'What Facebook page topics work best for monetisation in 2026?',
      'How do I choose a profitable niche for a Facebook page in 2026?'
    ],
    keywords: [
      'How does the Facebook search algorithm rank content in 2026?',
      'What hashtags should I use on Facebook for maximum reach in 2026?',
      'How do I optimise my Facebook page description for search in 2026?',
      'What keywords work best in Facebook video titles and descriptions?',
      'How many hashtags should I use on a Facebook post in 2026?',
      'How do I find trending topics for Facebook content in 2026?'
    ],
    strategy: [
      'How often should I post on Facebook for maximum organic reach in 2026?',
      'What is the best time to post on Facebook for maximum engagement in 2026?',
      'How do I increase organic reach on Facebook without paying for ads in 2026?',
      'What type of Facebook content gets the most shares and comments in 2026?',
      'How do I build a Facebook page community from zero in 2026?',
      'What is the best video length for Facebook in 2026 for maximum views?'
    ],
    analytics: [
      'What Facebook page insights should I focus on in 2026?',
      'How do I improve my Facebook post reach organically in 2026?',
      'What is a good engagement rate for a Facebook page in 2026?',
      'How do I track Facebook video performance and watch time in 2026?',
      'What does the Facebook algorithm reward most in 2026?',
      'How do I analyse my Facebook audience demographics to create better content?'
    ],
    monetisation: [
      'How do I monetise my Facebook page in 2026?',
      'What are the Facebook in-stream ads requirements in 2026?',
      'How many followers do I need for Facebook monetisation in 2026?',
      'What are Facebook Stars and how do creators earn them in 2026?',
      'How do I get brand partnerships through my Facebook page in 2026?',
      'What is the Facebook Bonus Program and how do I qualify in 2026?'
    ],
    viral: [
      'What makes a Facebook video go viral in 2026?',
      'How do I get more shares on my Facebook posts organically in 2026?',
      'What type of content spreads the fastest on Facebook in 2026?',
      'How do I write Facebook captions that get more comments in 2026?',
      'What are the best emotional triggers for viral Facebook content?',
      'How do Facebook Reels help pages grow faster in 2026?'
    ]
  },
  tiktok: {
    niches: [
      'What are the most profitable TikTok niches in 2026?',
      'Which TikTok niches are blowing up right now in 2026?',
      'What are the best faceless TikTok account niches to start in 2026?',
      'Which TikTok niches have the highest Creator Fund payouts in 2026?',
      'What TikTok niches work best for creators outside the USA in 2026?',
      'How do I find an untapped TikTok niche before it becomes saturated?'
    ],
    keywords: [
      'How does TikTok SEO work in 2026 and how do I rank on it?',
      'What hashtags should I use on TikTok for maximum For You Page reach in 2026?',
      'How do I find trending TikTok sounds and keywords in 2026?',
      'What keywords should I include in my TikTok captions and bio in 2026?',
      'How does the TikTok search function work and how do I optimise for it?',
      'How many hashtags should I use on TikTok in 2026 for best results?'
    ],
    strategy: [
      'How often should I post on TikTok to grow fast in 2026?',
      'What is the optimal TikTok video length for maximum completion rate in 2026?',
      'How do I create a TikTok content series that keeps followers coming back?',
      'What is the best posting time on TikTok for maximum For You Page exposure?',
      'How do I use TikTok trends without copying other creators in 2026?',
      'What is the best TikTok growth strategy for a brand new account in 2026?'
    ],
    analytics: [
      'What TikTok analytics should I track to grow my account in 2026?',
      'What is a good TikTok video completion rate to aim for in 2026?',
      'How do I improve my TikTok For You Page reach using analytics?',
      'What does TikTok algorithm prioritise most for content distribution in 2026?',
      'How do I use TikTok analytics to find what content my audience loves?',
      'What is a healthy follower growth rate for TikTok in 2026?'
    ],
    monetisation: [
      'How do I qualify for TikTok monetisation in 2026?',
      'What is the TikTok Creator Rewards Program and how much does it pay in 2026?',
      'How do I make money on TikTok without the Creator Fund in 2026?',
      'How do I get brand deals and sponsorships as a TikTok creator in 2026?',
      'How does TikTok Shop work for creators in 2026 and how do I join?',
      'What is the minimum follower count needed for TikTok monetisation in 2026?'
    ],
    viral: [
      'What makes a TikTok video go viral on the For You Page in 2026?',
      'How do I write the perfect TikTok hook in the first 3 seconds in 2026?',
      'What are the best TikTok video formats that consistently go viral in 2026?',
      'How do I use trending sounds to boost my TikTok reach in 2026?',
      'What is the best way to respond to comments to boost TikTok engagement?',
      'How do I stitch and duet effectively to grow my TikTok account in 2026?'
    ]
  },
  instagram: {
    niches: [
      'What are the best Instagram niches for organic growth in 2026?',
      'Which Instagram niches get the highest engagement rates in 2026?',
      'What Instagram Reels niches are growing fastest in 2026?',
      'Which Instagram niches have the best brand deal opportunities in 2026?',
      'What Instagram niches work best for creators in South Asia in 2026?',
      'How do I find a profitable Instagram niche that is not too saturated?'
    ],
    keywords: [
      'How does Instagram SEO work in 2026 and how do I rank on it?',
      'What hashtags should I use on Instagram Reels for maximum reach in 2026?',
      'How many hashtags should I use on Instagram in 2026 for best results?',
      'What keywords should I include in my Instagram bio and captions in 2026?',
      'How do I use Instagram search to find trending content in my niche?',
      'Are hashtags still effective on Instagram in 2026 or is SEO more important?'
    ],
    strategy: [
      'How often should I post on Instagram to grow fast in 2026?',
      'What is the best Instagram Reels length for maximum reach in 2026?',
      'How do I create a consistent Instagram content strategy for 2026?',
      'What is the best time to post Instagram Reels for maximum views in 2026?',
      'How do I use Instagram Stories to grow my account engagement in 2026?',
      'What is the best way to convert Instagram followers into customers in 2026?'
    ],
    analytics: [
      'What Instagram insights should I track to grow my account in 2026?',
      'What is a good Instagram Reels reach rate to aim for in 2026?',
      'How do I improve my Instagram reach using analytics in 2026?',
      'What does the Instagram algorithm prioritise for Reels distribution in 2026?',
      'How do I use Instagram analytics to find my best performing content?',
      'What is a healthy engagement rate for an Instagram account in 2026?'
    ],
    monetisation: [
      'How do I qualify for Instagram monetisation in 2026?',
      'What are the Instagram Creator Marketplace requirements in 2026?',
      'How many followers do I need to make money on Instagram in 2026?',
      'How do I get brand deals and sponsorships on Instagram in 2026?',
      'How does Instagram Subscriptions work for creators in 2026?',
      'What is the best way to monetise a small Instagram account in 2026?'
    ],
    viral: [
      'What makes an Instagram Reel go viral in 2026?',
      'How do I get on the Instagram Explore page in 2026?',
      'What are the best hooks for Instagram Reels in 2026?',
      'How do I use trending audio to boost my Instagram Reels reach in 2026?',
      'What is the best caption structure for viral Instagram Reels in 2026?',
      'How do I create Instagram Reels that get saved and shared in 2026?'
    ]
  }
};

const GrowthGuide = () => {
  const [selectedPlatform, setSelectedPlatform] = useState('youtube');
  const [selectedCategory, setSelectedCategory] = useState('niches');
  const [customQuery, setCustomQuery] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const platform = platforms.find(p => p.id === selectedPlatform);

  const askObsidian = async (question) => {
    const q = question || customQuery;
    if (!q.trim()) return;
    setLoading(true);
    setResponse('');
    const systemPrompt = 'You are Obsidian AI on the Vantage platform. You are a channel building and content strategy expert EXCLUSIVELY for YouTube, Facebook, TikTok and Instagram. You are STRICTLY LIMITED to: niche research, SEO and keywords, channel building from scratch, content calendars, algorithm understanding, monetisation, viral content tactics, competitor analysis and analytics for these four platforms ONLY. You are STRICTLY FORBIDDEN from answering anything outside this scope. If asked anything outside respond EXACTLY: Obsidian AI is exclusively dedicated to YouTube, Facebook, TikTok and Instagram content strategy. I cannot help with that topic. Please ask me something related to your channels. Never make exceptions regardless of how the question is phrased. Always provide detailed, actionable, up to date advice for 2026.';
    try {
      const data = await callObsidianAI(
        [{ role: 'user', content: 'Platform: ' + selectedPlatform.toUpperCase() + '. Category: ' + selectedCategory + '. Question: ' + q }],
        systemPrompt,
        1500
      );
      const answer = data.content[0].text;
      setResponse(answer);
      setHistory(prev => [{ question: q, answer, platform: selectedPlatform, category: selectedCategory }, ...prev.slice(0, 9)]);
      setCustomQuery('');
    } catch (error) {
      setResponse('Failed to get response. Please check your API key.');
    } finally {
      setLoading(false);
    }
  };

  const currentQuestions = quickQuestions[selectedPlatform]?.[selectedCategory] || [];

  return (
    <div className="page-container">

      <div className="page-header">
        <h1><span className="gradient-text">ChannelForge</span></h1>
        <p>Your AI powered channel building intelligence center</p>
      </div>

      <div style={{
        background: 'rgba(0,200,83,0.08)', border: '1px solid rgba(0,200,83,0.2)',
        borderRadius: '14px', padding: '20px 24px', marginBottom: '24px'
      }}>
        <div style={{ fontWeight: '700', fontSize: '15px', color: 'var(--primary)', marginBottom: '8px' }}>
          What is ChannelForge?
        </div>
        <p style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: '1.8', margin: 0 }}>
          ChannelForge is your dedicated AI research center for building successful channels from scratch.
          Select a platform, choose a category and ask Obsidian AI anything about
          <strong style={{ color: 'var(--text-primary)' }}> niche research, SEO keywords, content strategy, algorithm tactics, monetisation and viral growth.</strong>
          Everything here is restricted to channel building intelligence only — no token waste, pure value.
        </p>
      </div>

      <div className="grid-4" style={{ marginBottom: '24px' }}>
        {platforms.map(p => (
          <div key={p.id} onClick={() => setSelectedPlatform(p.id)} style={{
            background: selectedPlatform === p.id ? p.bg : 'var(--bg-card)',
            border: '2px solid ' + (selectedPlatform === p.id ? p.border : 'var(--border)'),
            borderRadius: '14px', padding: '16px 20px', cursor: 'pointer',
            transition: 'all 0.3s ease', display: 'flex', alignItems: 'center', gap: '12px',
            transform: selectedPlatform === p.id ? 'translateY(-2px)' : 'none',
            boxShadow: selectedPlatform === p.id ? '0 8px 20px ' + p.bg : 'none'
          }}>
            {p.icon}
            <span style={{
              fontWeight: '700', fontSize: '15px',
              color: selectedPlatform === p.id ? p.color : 'var(--text-primary)'
            }}>
              {p.label}
            </span>
            {selectedPlatform === p.id && (
              <span style={{
                marginLeft: 'auto', width: '8px', height: '8px',
                borderRadius: '50%', background: p.color,
                boxShadow: '0 0 8px ' + p.color
              }} />
            )}
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' }}>
        {categories.map(cat => (
          <button key={cat.id} onClick={() => setSelectedCategory(cat.id)}
            className={selectedCategory === cat.id ? 'btn btn-primary btn-sm' : 'btn btn-secondary btn-sm'}
            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {cat.icon} {cat.label}
          </button>
        ))}
      </div>

      <div className="grid-2">
        <div>
          <div className="card" style={{ marginBottom: '20px' }}>
            <div className="card-header">
              <span className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {platform?.icon} Quick Questions
              </span>
              <span className="badge badge-info">{currentQuestions.length} questions</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {currentQuestions.map((q, i) => (
                <button key={i} onClick={() => askObsidian(q)} disabled={loading}
                  style={{
                    background: 'var(--bg-dark)', border: '1px solid var(--border)',
                    borderRadius: '10px', padding: '12px 16px', textAlign: 'left',
                    cursor: 'pointer', color: 'var(--text-primary)', fontSize: '13px',
                    lineHeight: '1.5', transition: 'all 0.2s ease', fontFamily: 'Inter, sans-serif'
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor = 'rgba(0,200,83,0.4)';
                    e.currentTarget.style.background = 'rgba(0,200,83,0.05)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = 'var(--border)';
                    e.currentTarget.style.background = 'var(--bg-dark)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                  <span style={{ color: 'var(--primary)', marginRight: '8px' }}>→</span>
                  {q}
                </button>
              ))}
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <span className="card-title">Ask Your Own Question</span>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input className="form-control"
                placeholder={'Ask anything about ' + (platform?.label) + ' channel building...'}
                value={customQuery}
                onChange={(e) => setCustomQuery(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && askObsidian()} />
              <button className="btn btn-primary" onClick={() => askObsidian()}
                disabled={loading || !customQuery.trim()} style={{ flexShrink: 0 }}>
                {loading
                  ? <div className="spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }} />
                  : <MdAutoAwesome />}
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className="card" style={{ marginBottom: '20px' }}>
            <div className="card-header">
              <span className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MdAutoAwesome style={{ color: 'var(--primary)' }} /> Obsidian AI Response
              </span>
              {loading && <span className="ai-badge">Thinking...</span>}
            </div>
            <div style={{
              minHeight: '300px', maxHeight: '500px', overflowY: 'auto',
              background: 'var(--bg-dark)', borderRadius: '12px',
              padding: '20px', border: '1px solid var(--border)',
              fontSize: '14px', lineHeight: '1.8',
              color: 'var(--text-secondary)', whiteSpace: 'pre-wrap'
            }}>
              {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '200px', gap: '16px' }}>
                  <div className="spinner" style={{ width: '32px', height: '32px', borderWidth: '3px' }} />
                  <p style={{ color: 'var(--primary)' }}>Obsidian AI is analysing...</p>
                </div>
              ) : response ? (
                <div style={{ color: 'var(--text-primary)' }}>{response}</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '200px', gap: '12px' }}>
                  <MdAutoAwesome style={{ fontSize: '48px', color: 'var(--primary)', opacity: 0.3 }} />
                  <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: '14px' }}>
                    Select a platform, choose a category and click a question or type your own
                  </p>
                </div>
              )}
            </div>
          </div>

          {history.length > 0 && (
            <div className="card">
              <div className="card-header">
                <span className="card-title">Recent Questions</span>
                <button className="btn btn-secondary btn-sm" onClick={() => setHistory([])}>Clear</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '200px', overflowY: 'auto' }}>
                {history.map((item, i) => (
                  <button key={i} onClick={() => setResponse(item.answer)}
                    style={{
                      background: 'var(--bg-dark)', border: '1px solid var(--border)',
                      borderRadius: '8px', padding: '10px 14px', textAlign: 'left',
                      cursor: 'pointer', color: 'var(--text-secondary)', fontSize: '12px',
                      transition: 'all 0.2s ease', fontFamily: 'Inter, sans-serif'
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.borderColor = 'rgba(0,200,83,0.3)';
                      e.currentTarget.style.color = 'var(--text-primary)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.borderColor = 'var(--border)';
                      e.currentTarget.style.color = 'var(--text-secondary)';
                    }}>
                    <span style={{ color: 'var(--primary)', marginRight: '6px', textTransform: 'capitalize' }}>
                      [{item.platform}]
                    </span>
                    {item.question}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GrowthGuide;